import { render } from "./TermsDoc.vue?vue&type=template&id=c4197f50"
import script from "./TermsDoc.vue?vue&type=script&lang=js"
export * from "./TermsDoc.vue?vue&type=script&lang=js"

import "./TermsDoc.vue?vue&type=style&index=0&id=c4197f50&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__